module.exports = __webpack_public_path__ + "images/breedveld_smallfde4d8fdc358dfb2ec83ad7259996b3b.png";